import { Wizard } from "@/components/instance/LaunchInstanceWizard";
import { useLocation } from "react-router-dom";

export const LaunchNodegroup = () => {
  const location = useLocation();
  const { key, resource } = location.state || {};
  const title = "actions.launchNodegroup";
  const description = "actionsDesc.launchNodegroup";

  return (
    <Wizard
      instanceType={key}
      resource={resource}
      title={title}
      description={description}
    />
  );
};
